module.exports = __webpack_public_path__ + "static/media/icon-indiferente.6d9812ca.svg";